/**
 * Non-blocking banner when leads count scheduler is running (backend).
 * Shown across the app; survives refresh.
 * For Media Devoted | Created By Ciro Autiero
 */

import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

import { LoadingSpinner } from '@/components/ui';
import { useSchedulerStatus } from '@/hooks';

export function SchedulerBanner() {
  const { data: status } = useSchedulerStatus();
  const isRunning = status?.isRunning ?? false;
  const progress = status?.progress;

  if (!isRunning || !progress || (progress.status !== 'running' && progress.status !== 'paused')) {
    return null;
  }

  return (
    <div className="flex shrink-0 items-center gap-3 border-b border-border bg-primary/5 px-4 py-2 text-sm">
      <LoadingSpinner size="sm" className="text-primary" />
      <span className="font-medium text-foreground">Fetching leads count</span>
      <span className="text-muted-foreground">
        {progress.totalPending} remaining
        {progress.fetched > 0 && (
          <> · {progress.fetched} fetched</>
        )}
      </span>
      <Link
        to="/admin/fetch-leads-counts"
        className="ml-auto flex items-center gap-1.5 text-primary hover:underline"
      >
        <RefreshCw className="h-3.5 w-3.5" />
        View progress
      </Link>
    </div>
  );
}
